/**
 * @file component用Mixin
 * @namespace mixins
 */

import controls from '@/rahmen/controls'

/**
 * @module inputMixins
 */
/**
 * @vue-data {String} [invalidMessage=''] - エラーメッセージ
 * @vue-prop {Array} [appendValidators=[]] - 追加バリデーター
 */
export default {
  props: {
    appendValidators: Array
  },
  data: () => ({
    invalidMessage: ''
  }),
  methods: {
    [controls.SET_INVALID_METHOD]: function (message) {
      console.log(controls.SET_INVALID_METHOD, message)
      this.invalidMessage = message
    },
    [controls.GET_INVALID_METHOD]: function () {
      return this.invalidMessage
    },
    [controls.CLEAR_INVALID_METHOD]: function () {
      console.log(controls.CLEAR_INVALID_METHOD)
      this.invalidMessage = undefined
    }
  }
}
